import SemenSearch from '../../semen/forms/search';
import AnimalDonorSearch from '../../animals/forms/search';
import { useRacesList } from '../../races/contexts/races';
import { STAGES, PRESERVATION } from '../../../core/constants/clivage';

// Campos del alta de embrión externo (admin-embryos.md). Padre = semen (SemenSearch).
// Donante nested-or-ref (0021 §1): EXISTENTE (AnimalDonorSearch → donor_id) o NUEVA
// referencia (nombre + raza → donor_animal). Preservación, estadio, sexo, grado opcionales.
export default function EmbryoFields({ form, setField, fieldError, disabled }) {
    const { data: racesData } = useRacesList({});
    const races = racesData?.items ?? [];
    const isNew = form.donorMode === 'new';

    return (
        <div className="cat-form__grid">
            <label className="cat-form__field">
                <span className="cat-form__label">Semen (padre)</span>
                <SemenSearch value={form.semen} onSelect={(s) => setField('semen', s)} onClear={() => setField('semen', null)} />
                {fieldError('semen') && <span className="cat-form__error" role="alert">{fieldError('semen')}</span>}
            </label>

            <label className="cat-form__field">
                <span className="cat-form__label">Código de la pajuela</span>
                <input type="text" value={form.code} onChange={(e) => setField('code', e.target.value)} maxLength={40} disabled={disabled} placeholder="Etiqueta física · único" aria-invalid={!!fieldError('code')} />
                {fieldError('code') && <span className="cat-form__error" role="alert">{fieldError('code')}</span>}
            </label>

            <div className="cat-form__field cat-form__field--full">
                <span className="cat-form__label">Donante (madre)</span>
                <div className="cat-form__toggle" role="group" aria-label="Tipo de donante">
                    <button type="button" className={`cat-form__toggle-btn ${!isNew ? 'cat-form__toggle-btn--active' : ''}`} onClick={() => setField('donorMode', 'existing')} disabled={disabled}>Existente</button>
                    <button type="button" className={`cat-form__toggle-btn ${isNew ? 'cat-form__toggle-btn--active' : ''}`} onClick={() => setField('donorMode', 'new')} disabled={disabled}>Nueva (referencia)</button>
                </div>
                <span className="cat-form__hint">Una donante nueva se crea como referencia externa (no entra al inventario de animales con número).</span>
            </div>

            {!isNew ? (
                <label className="cat-form__field cat-form__field--full">
                    <span className="cat-form__label">Buscar donante</span>
                    <AnimalDonorSearch value={form.donor} onSelect={(a) => setField('donor', a)} onClear={() => setField('donor', null)} sex="female" />
                    {fieldError('donor') && <span className="cat-form__error" role="alert">{fieldError('donor')}</span>}
                </label>
            ) : (
                <>
                    <label className="cat-form__field">
                        <span className="cat-form__label">Nombre de la donante</span>
                        <input type="text" value={form.donor_name} onChange={(e) => setField('donor_name', e.target.value)} maxLength={120} disabled={disabled} aria-invalid={!!fieldError('donor_name')} />
                        {fieldError('donor_name') && <span className="cat-form__error" role="alert">{fieldError('donor_name')}</span>}
                    </label>
                    <label className="cat-form__field">
                        <span className="cat-form__label">Raza de la donante</span>
                        <select value={form.donor_race_id} onChange={(e) => setField('donor_race_id', e.target.value)} disabled={disabled} aria-invalid={!!fieldError('donor_race_id')}>
                            <option value="">Seleccionar…</option>
                            {races.map((r) => <option key={r.id} value={r.id}>{r.name}</option>)}
                        </select>
                        {fieldError('donor_race_id') && <span className="cat-form__error" role="alert">{fieldError('donor_race_id')}</span>}
                    </label>
                    <label className="cat-form__field cat-form__field--full">
                        <span className="cat-form__label">Registro de la donante</span>
                        <input type="text" value={form.donor_register} onChange={(e) => setField('donor_register', e.target.value)} maxLength={60} disabled={disabled} placeholder="Opcional · único" aria-invalid={!!fieldError('donor_register')} />
                        {fieldError('donor_register') && <span className="cat-form__error" role="alert">{fieldError('donor_register')}</span>}
                    </label>
                </>
            )}

            <label className="cat-form__field">
                <span className="cat-form__label">Preservación</span>
                <select value={form.preservation} onChange={(e) => setField('preservation', e.target.value)} disabled={disabled}>
                    {PRESERVATION.map((p) => <option key={p.value} value={p.value}>{p.label}</option>)}
                </select>
            </label>

            <label className="cat-form__field">
                <span className="cat-form__label">Estadio</span>
                <select value={form.stage} onChange={(e) => setField('stage', e.target.value)} disabled={disabled}>
                    <option value="">Sin especificar</option>
                    {STAGES.map((s) => <option key={s.value} value={s.value}>{s.label}</option>)}
                </select>
                {form.stage === 'DG' && <span className="cat-form__hint">DG (degenerado): no se crea registro, se descarta (0025).</span>}
            </label>

            <label className="cat-form__field">
                <span className="cat-form__label">Sexo (si sexado)</span>
                <select value={form.sex} onChange={(e) => setField('sex', e.target.value)} disabled={disabled}>
                    <option value="">Sin sexar</option>
                    <option value="female">Hembra</option>
                    <option value="male">Macho</option>
                </select>
            </label>

            <label className="cat-form__field">
                <span className="cat-form__label">Grado / calidad</span>
                <input type="text" value={form.quality} onChange={(e) => setField('quality', e.target.value)} maxLength={20} disabled={disabled} placeholder="Opcional" />
            </label>

            <label className="cat-form__field cat-form__field--full">
                <span className="cat-form__label">Notas</span>
                <textarea value={form.remarks} onChange={(e) => setField('remarks', e.target.value)} rows={3} disabled={disabled} placeholder="Ubicación, observaciones (opcional)" />
            </label>
        </div>
    );
}
